import { NgClass } from '@angular/common';
import { AfterContentChecked, Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { SingleFocusService } from 'components/input/editable-content/editable-content.component';

@Component({
	selector: 'data-table',
	template: '<div class="row">' +
		'<ng-content select="data-row,edit-row,ng-container"></ng-content>' +
		'</div>',
	styleUrls: ['./data-table.component.scss'],
	providers: [SingleFocusService]
})
export class DataTableComponent { }

@Component({
	selector: 'data-row',
	templateUrl: 'data-row.component.html',
	imports: [NgClass]
})
export class DataRowComponent implements AfterContentChecked {

	@ViewChild('inputContent') inputContent?: ElementRef<HTMLElement>;
	@ViewChild('rawContent') rawContent?: ElementRef<HTMLElement>;
	@ViewChild('prefixContent') prefixContent?: ElementRef<HTMLElement>;
	
	hasInput = false;
	hasRawContent = false;
	hasPrefixContent = false;
	focusedInput = false;
	hover = false;
	inputCheckbox = false;

	@HostBinding('class')
	get columnClass() {
		let classes = 'col-' + this.columnWidth;
		if (this.focusedInput) classes += ' focus';
		if (this.hover) classes += ' hover';
		if (this.inputCheckbox) classes += ' checkbox';
		return classes;
	}
	private columnWidth = 12;
	@Input() set columns(columns: string | number | undefined) {
		if (typeof columns === 'number') this.columnWidth = columns;
		else this.columnWidth = columns ? parseInt(columns) : 12;
	}
	@Input() image?: string;

	ngAfterContentChecked(): void {
		if (this.inputContent && this.inputContent.nativeElement && this.inputContent.nativeElement.children.length > 0) {
			this.hasInput = true;
			this.inputCheckbox = this.inputContent.nativeElement.children[0].getAttribute('type') == 'checkbox';
		}
		if (this.rawContent && this.rawContent.nativeElement) {
			if (this.rawContent.nativeElement.children.length > 0) this.hasRawContent = true;
			if (this.rawContent.nativeElement.textContent && this.rawContent.nativeElement.textContent.trim().length > 0) this.hasRawContent = true;
		}
		if (this.prefixContent && this.prefixContent.nativeElement && this.prefixContent.nativeElement.children.length > 0) {
			this.hasPrefixContent = true;
		}
	}
}
